import { Link } from 'react-router';
import { Button } from '@/components/ui/button';
import { ROUTES } from '@/config/routes';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background px-6 text-center">
      <p className="text-sm font-medium text-muted-foreground">404</p>
      <h1 className="text-2xl font-semibold tracking-tight">페이지를 찾을 수 없습니다</h1>
      <p className="text-sm text-muted-foreground">주소가 잘못되었거나 삭제된 페이지입니다.</p>
      <Button asChild>
        <Link to={ROUTES.home}>홈으로</Link>
      </Button>
    </div>
  );
}
